<!-- 添加订单 -->
<template>
  <el-form
    ref="ruleForm"
    v-loading="loading"
    :model="ruleForm"
    size="small"
    label-position="top"
    :rules="rules"
  >
    <!--    干支线业务-->
    <template v-if="payableType === 5">
      <!-- 运输单号 -->
      <el-form-item :label="$t('basicData.TransportOrderNumber')" prop="ids">
        <el-input
          v-model="ruleForm.ids" type="textarea" :autosize="{ minRows: 6, maxRows: 10}"
          :placeholder="$t('receivablePayable.notReturnQueryTip')"
        />
      </el-form-item>
    </template>
    <template v-else>
      <!-- 业务类型 -->
      <el-form-item :label="$t('collectionCenter.businessT')" prop="payableType">
        <el-select v-model="ruleForm.payableType" :disabled="isBusinessTypeSelect" style="width: 100%;">
          <el-option
            v-for="item in PAYABLE_TYPE"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <!-- 条形码/扫描单号 -->
      <el-form-item :label="`${$t('collectionCenter.Barcode')}/${$t('GlobalSetObj.ScanNumber')}`" prop="ids">
        <el-input
          v-model="ruleForm.ids" type="textarea" :autosize="{ minRows: 6, maxRows: 10}"
          :placeholder="$t('trajectory.multipleOrders')"
        />
      </el-form-item>
    </template>
    <el-form-item>
      <el-button type="primary" @click="submitForm('ruleForm')">{{ $t('GlobalSetObj.determine') }}</el-button>
      <el-button @click="onClose">{{ $t('GlobalSetObj.cancel') }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { apiGetClAndLgInfo } from '@/api/finance/basicData';
import {
  apiPayableTransportExpenseGetTransportOrders
} from '@/api/finance/receivables';
import { PAYABLE_TYPE } from '@/views/finance/enums';

export default {
  props: {
    // 业务类型
    businessType: {
      type: Number,
      required: true
    },

    // 业务类型 是否禁用
    isBusinessTypeSelect: {
      type: Boolean,
      default: false
    },

    // 账单类型
    payableType: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      loading: false,

      ruleForm: {
        payableType: '',
        ids: ''
      },
      rules: {
        businessType: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        ids: [
          { required: true, validator: this.validateIds, trigger: 'blur' }
        ]
      },
      PAYABLE_TYPE
    };
  },

  watch: {
    payableType: {
      handler(val) {
        this.ruleForm.payableType = val;
        this.ruleForm.ids = '';
      },

      immediate: true
    }
  },

  methods: {
    // 验证器
    validateIds(rule, value, callback) {
      const arr = this.getCodeArr(value || '');
      if (arr.length === 0) {
        callback(new Error(this.$t('GlobalSetObj.pleaseInput')));
        return;
      }
      callback();
    },

    // 订单查询
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const { ids } = this.ruleForm;
          const arr = this.getCodeArr(ids);
          const obj = {
            businessType: this.businessType,
            payableType: this.payableType,
            ids: arr
          };
          this.queryTransportOrders(obj);
        }
      });
    },

    // 获取条形码
    getCodeArr(str) {
      return str.split(/[\r\n]+/).filter(Boolean);
    },

    // 请求查询
    async queryTransportOrders(obj) {
      try {
        const isTransportType = this.payableType === 5;
        const API = isTransportType
          ? apiPayableTransportExpenseGetTransportOrders // 运输单
          : apiGetClAndLgInfo; // 快递订单
        const params = isTransportType
          ? { transportNumberList: obj.ids }
          : obj;
        this.loading = true;
        const res = await API(params);
        if (res.code === 200) {
          const { successResult = [], failResult = [] } = res.data;
          if (successResult.length === 0 && failResult.length === 0) {
            this.$message.warning(this.$t('operationCenter.TheOrderWasNotQueried')); // 未查询到订单
            return;
          }
          // 显示错误结果
          this.showFailResult(failResult);
          // 设置数据格式

          const arr = this.setDataType(successResult);
          console.log(arr);
          this.$emit('submit', arr);
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    },

    // 显示错误结果
    showFailResult(failResult, errorKey = 'orderCenterCont.orderInformationIncorrect') {
      if (failResult.length === 0) return;
      const arr = failResult.join('、');
      this.$message({
        message: `${arr} ${this.$t(errorKey)}`,
        type: 'warning',
        duration: 5000,
        showClose: true
      });
    },

    // 设置数据格式
    setDataType(arr) {
      return arr.map(item => {
        const { id, businessType, waybillNumber, customerNumber, providerId, providerName, siteId, siteName, customerAlias, chargeWeight, scanOrderNumber, transportNumber, lineName, routeTypeStr } = item;
        return {
          id,
          businessType, // 业务类型
          waybillNumber, // 业务订单
          scanOrderNumber, // 揽收单号
          customerNumber, // 客户单号
          providerId, // 业务主体id
          providerName, // 业务主体
          siteId, // 网点
          siteName,
          customerAlias, // 客户
          chargeWeight, // 计费重量
          transportNumber, // 运输单
          lineName, // 车线名称
          routeTypeStr // 运输类型
        };
      });
    },

    onClose() {
      this.$refs.ruleForm.resetFields();
      this.$emit('close');
    }
  }
};
</script>
